import React, { useCallback, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useStyles } from './styles';
import { appConfig, UPLOAD_DATA_PATH } from '../../../constants';
import EnrichmentModal from '../../containers/DataManagementPage/widgets/AriesPage/EnrichmentModal';
import { useEnrichment } from '../../context/EnrichmentContext';

export function AiresUploadButton({
  title = 'Upload AIRES Files',
  isBirthdayUpload = false,
}: {
  title?: string;
  isBirthdayUpload?: boolean;
}) {
  const [enrichmentRunningModalOpen, setEnrichmentRunningModalOpen] =
    useState(false);

  const { enrichmentProcessing } = useEnrichment();

  const classes = useStyles();

  const handleClick = useCallback(() => {
    if (enrichmentProcessing) {
      setEnrichmentRunningModalOpen(true);
    } else {
      window.location.href = `${appConfig.urls.myData}/#${UPLOAD_DATA_PATH}`;
    }
  }, [enrichmentProcessing]);

  return (
    <>
      <EnrichmentModal
        isOpen={enrichmentRunningModalOpen}
        title="File Upload Unavailable"
        description="File cannot be uploaded because the enrichment process you started earlier is still running. Please wait until it finishes."
        cancelFunc={() => {
          setEnrichmentRunningModalOpen(false);
        }}
      />
      {!isBirthdayUpload ? (
        <Button
          classes={{
            root: classes.button,
            label: classes.buttonLabel,
          }}
          variant="contained"
          onClick={handleClick}
        >
          {title}
        </Button>
      ) : (
        <Button
          classes={{
            root: classes.textButton,
            label: classes.textButtonLabel,
          }}
          onClick={handleClick}
          disableRipple
        >
          Add dates of birth
        </Button>
      )}
    </>
  );
}
